export const DEFAULT_PAGE_SIZE = 50;
export const PAGINATION_FIRST_PAGE = 'start';
export const SORT_FIELDS = {
    DATE_CREATED: 'date_created',
    LAST_ACTION: 'last_action',
};
export const SORT_ORDERS = {
    ASC: 'asc',
    DESC: 'desc',
};
export const EXPORT_COMMENT_LIMIT = 5000;
export const EXPORT_FILE_NAME = 'vf-search-results.csv';
export const EXPORT_SAVED_SEARCH = 'export_saved_search';
export const EXPORT_QUICK_SEARCH = 'export_quick_search';
